module.exports = __webpack_public_path__ + "img/20210906-1630912386918298.de5c90e2.png";